<div class="pagination-controls d-print-none" [class.pagination-controls--with-limit]="showLimitSelector" *transloco="let t">
  <div class="pagination-limit" *ngIf="showLimitSelector">
    <ng-select
      [items]="limitOptions"
      [clearable]="false"
      bindLabel="label"
      bindValue="value"
      class="form-control form-control-rounded"
      [ngModel]="pageSize"
      (ngModelChange)="changeLimit($event)"
    ></ng-select>
    <span>{{ t('shared/pageLimit') }}</span>
  </div>
  <ngb-pagination
    [(page)]="page"
    (pageChange)="pageChange.emit($event)"
    [collectionSize]="collectionSize"
    [pageSize]="pageSize"
    [maxSize]="maxSize"
  ></ngb-pagination>
</div>
